import { RegistroStatus } from './genericTypes';

export const errorMessages = {
  api: {
    error: 'Sistema temporariamente fora, tente novamente mais tarde',
  },
  participante: {
    submit: 'Houve um erro ao salvar as informações do Participante. Tente novamente.',
    cpfDuplicado: 'Já existe um Representante Legal com este CPF',
    cpfInvalido: 'Esse CPF é inválido. Tente novamente.',
    cpfUsuario: 'Já existe um Usuário com este cpf, por favor insira todos os Repesentantes Legais primeiro.',
    emailInvalido: 'Esse email é inválido. Tente novamente.',
    emailDuplicado: 'Já existe um Representante Legal com este email',
    emailUsuario: 'Já existe um Usuário com este email, por favor insira todos os Repesentantes Legais primeiro.',
  },
  usuario: {
    submit: 'Houve um erro ao salvar as informações do Usuário. Tente novamente.',
    cpfDuplicado: 'Já existe um Usuário com este CPF',
    cpfInvalido: 'Esse CPF é inválido. Tente novamente.',
    emailInvalido: 'Esse email é inválido. Tente novamente.',
    emailDuplicado: 'Já existe um Usuário com este email',
  },
  investidor: {
    submit: 'Houve um erro ao salvar as informações do Investidor. Tente novamente.',
    cpfDuplicado: 'Já existe um Representante Legal com este CPF',
    cpfInvalido: 'Esse CPF é inválido. Tente novamente.',
  },
  instrumentoFinanceiro: {
    generic: 'Houve um erro no cadastro.',
    eventosFinanceiros: {
      eventoInvalido:
        'O arquivo contém Evento Financeiro inválido. Apenas eventos financeiros "A" (Amortização), "P" (Pagamentos de Juros) ou "I" (Incorporação de Juros) são automaticamente reconhecidos',
      dataInvalida:
        'O arquivo contém data em formato inválido. Apenas datas no formato "DD/MM/YYYY", tais como 31/12/2021, são automaticamente reconhecidas',
      percentualAmortizacao: 
        'O arquivo contém Evento Financeiro de Amortização com valor percentual inválido',
      emailInvalido: 
        'Esse email é inválido. Tente novamente.',
      emailDuplicado: 
        'Esse email já foi adicionado',
    },
  },
  validation: {
    requiredFields: 'Obrigatório rejeitar com justificativa ou anexo.',
    upload: {
      invalidExtension: 'A extensão do arquivo não é permitida',
      invalidData: 'O arquivo contém dados inválidos',
    },
    instrumentoFinanceiro: {
      generic: (status: RegistroStatus) => {
        switch (status) {
          case RegistroStatus.Aprovado:
            return 'Houve um erro na aprovação do instrumento financeiro.';
          case RegistroStatus.AguardandoCorrecao:
          case RegistroStatus.Reprovado:
            return 'Houve um erro na rejeição do instrumento financeiro.';
          default:
            return 'Houve um erro na validação do instrumento financeiro.';
        }
      },
    },
    participante: {
      generic: (status: RegistroStatus) => {
        switch (status) {
          case RegistroStatus.Aprovado:
            return 'Houve um erro na aprovação do participante.';
          case RegistroStatus.AguardandoCorrecao:
          case RegistroStatus.Reprovado:
            return 'Houve um erro na rejeição do participante.';
          default:
            return 'Houve um erro na validação do participante.';
        }
      },
    },
  },
};
